function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "876d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/js
// module id = 876d
// module chunks = 1